import React from "react";
import { Link, withPrefix } from "gatsby";
import styled from "styled-components";

const NavWrapper = styled.nav`
	li:not(:last-child) {
		border-right: 1px solid #ccc;
	}

	.bg-dark:focus {
		color: #fff !important;
	}
`;

const strippedPath = path =>
	path.replace(withPrefix("/"), "").replace(/\//g, "");

const NavLinkItem = ({ item, location }) => {
	return (
		<li key={item.id} className="nav-item">
			<Link
				to={item.url}
				className={`nav-link p-2 rounded-0${
					strippedPath(location.pathname) === strippedPath(item.url)
						? " bg-dark text-light border-0"
						: ""
				}`}
				state={{ fromNav: true }}
			>
				{item.displayText}
			</Link>
		</li>
	);
};

const MainNav = ({ menuItems, location, siteTitle }) => {
	return (
		<NavWrapper aria-label="Redistricting site navigation">
			<h2 id="sr-sitenav-title" className="sr-only">
				Redistricting site navigation
			</h2>
			<div className="container-fluid text-center bg-light border-bottom border-secondary p-0 px-xl-5">
				<div className="p-3">
					<Link
						to="/"
						className="h3 text-center w-100 text-dark text-light"
					>
						{siteTitle}
					</Link>
				</div>
				<div className="container-fluid p-0 m-0">
					<ul className="nav nav-pills nav-fill">
						{menuItems.map((item, i) => (
							<NavLinkItem
								item={item}
								location={location}
								key={`nav-link-item-${i}`}
							/>
						))}
					</ul>
				</div>
			</div>
		</NavWrapper>
	);
};

export default MainNav;
